import Home from "../features/Home/Home";
import Setting from "../features/Setting/Setting";
import Success from "../features/success/Success";
import Error from "../features/error/Error";
import FatalError from "../features/FatalError/FatalError";
import QrValidator from "../features/QrValidator/QrValidator";
import {useTranslation} from "react-i18next";
import {Navigate, useLocation} from "react-router-dom";
import LangLayout, {base, DEFAULT_LANG, withBase} from "./LangLayout";

function Routes() {
    const {t} = useTranslation();

    return [
        {
            path: withBase("/:lang"),
            element: <LangLayout/>,
            children: [
                {path: ":shopId/:marketMode?", element: <Home/>, title: t("routes.dashboard")},
                {path: "setting/:shopId", element: <Setting/>, title: t("routes.setting")},
                {path: "success/:shopId", element: <Success/>, title: t("routes.success")},
                {path: "error/:shopId", element: <Error/>, title: t("routes.error")},
                {path: "fatal-error/:shopId", element: <FatalError/>, title: t("routes.fatalError")},
                {path: "qr-validator/check", element: <QrValidator/>, title: t("routes.qrValidator")},
            ],
        },
        // Catch lang-less URLs like /home/5 or /setting/12
        {
            path: withBase("/*"),
            element: <RedirectToDefaultLang/>,
        },
    ];
}

function RedirectToDefaultLang() {
    const {pathname, search, hash} = useLocation();
    const stripped = pathname.slice(base.length);
    return <Navigate to={`${base}/${DEFAULT_LANG}${stripped}${search}${hash}`} replace/>;
}

export default Routes;
